<div class="fixed top-0 bottom-0 right-0 left-0 flex flex-col justify-center items-center bg-light-blue-overlay text-white z-1005">
  <img class="w-16 h-16 animate-bounce select-none" src="@Assets/img/map/pin-sensor.svg" alt="">
  <div class="mt-8 font-bold text-xl select-none">{{ computedLabel }}</div>
</div>
